import { Component, Inject, Input, OnInit } from '@angular/core';
import { CampaignManagerItemOfferModel, DATE_OPTIONS, DateOptions } from '@fgb/core';
import * as luxon from 'luxon';

@Component({
  selector: 'fgb-campaigns-v2-list-item',
  templateUrl: './campaigns-v2-list-item.component.html',
  styleUrls: ['./campaigns-v2-list-item.component.scss'],
})
export class CampaignsV2ListItemComponent implements OnInit {
  @Input() campaignEntitlement: CampaignManagerItemOfferModel;
  isDateExpired: boolean = false;

  constructor(@Inject(DATE_OPTIONS) public dateOption: DateOptions) {}

  ngOnInit(): void {
    const expiryDate = this.campaignEntitlement.ExpiryDate;
    if (!expiryDate) {
      this.isDateExpired = false;
      return;
    }
    const now = luxon.DateTime.utc();
    const expiredDate = luxon.DateTime.fromISO(expiryDate);
    this.isDateExpired = now > expiredDate;
  }
}
